import { createFileRoute } from "@tanstack/react-router"
import { BackofficeScheduledReportCreator } from "modules/backoffice/components/scheduledReports/BackofficeScheduledReportCreator"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/backoffice/scheduledReports/create")({
  component: BackofficeScheduledReportCreator,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("backoffice.scheduledReports.create.title"),
    })
  },
})
